export default {
  computed: {
    userRole () {
      return this.user && this.user?.roles?.length > 0 ? this.user?.roles : []
    },
    adminOwnerRoles () {
      return this.$store.getters['LoginStore/adminOwnerRoles'] || []
    },
    userIsAdminOwner () {
      return this.userRole.some(el => this.adminOwnerRoles.includes(el))
    },
    userIsAdmin () {
      return this.userRole.some(el => this.$store.getters['UsersStore/adminRoles'].includes(el))
    },
    userIsBook () {
      return this.userRole.some(el => this.$store.getters['UsersStore/accountingRoles'].includes(el))
    },
    userIsRegular () {
      return this.userRole.some(el => this.$store.getters['UsersStore/normalUserRoles'].includes(el))
    },
    userIsSuperAdmin () {
      return this.userRole.some(el => this.$store.getters['UsersStore/superAdminRoles'].includes(el))
    },
    userIsCommercial () {
      return this.userRole.some(el => this.$store.getters['UsersStore/commercialRoles'].includes(el))
    },
    userIsSuperBook () {
      return this.userRole.some(el => this.$store.getters['UsersStore/superBookRoles'].includes(el))
    },
    userRoleLabel () {
      if (this.userIsSuperAdmin) {
        return this.$i18n.t('user_role__ROLE_SUPER_ADMIN')
      }
      if (this.userIsCommercial) {
        return this.$i18n.t('user_role__ROLE_COMMERCIAL')
      }
      if (this.userIsSuperBook) {
        return this.$i18n.t('user_role__ROLE_SUPER_BOOKKEEPER')
      }
      if (this.userIsAdminOwner) {
        return this.$i18n.t('user_role__ROLE_ACCOUNT_HOLDER')
      }
      if (this.userIsAdmin) {
        return this.$i18n.t('user_role__ROLE_ADMIN')
      }
      if (this.userIsBook) {
        return this.$i18n.t('user_role__ROLE_BOOKKEEPER')
      }
      if (this.userIsRegular) {
        return this.$i18n.t('user_role__ROLE_REGULAR')
      }
      return ''
    }

  }
}
